import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { LoginSuccess } from "../Redux/actions/LoginAction";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { LoginTypeAction } from "../Redux/actions/LoginTypeAction";
import { sha512 } from "js-sha512";

const Loginwithoutcredential = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const login_data: any = useParams();

  useEffect(() => {
    const company_id = parseInt(window.atob(login_data.company_id));
    const comp_hash = sha512(company_id.toString());

    const send_login_data = {
      admin_id: parseInt(window.atob(login_data.admin_id)),
      auth_token: login_data.auth_token,
      company_id: company_id,
      full_name: window.atob(login_data.full_name),
      hotel_id: parseInt(window.atob(login_data.hotel_id)),
      hotel_name: window.atob(login_data.hotel_name),
      comp_hash: comp_hash,
    };

    dispatch(LoginSuccess(send_login_data));
    dispatch(LoginTypeAction("loginwithoutcred"));
    navigate("/dashboard");
  }, [dispatch, navigate, login_data]);

  return <></>;
};

export default Loginwithoutcredential;
